import React from "react";
import { useHistory } from "react-router-dom";
import "./admin.scss";

import { BsFillFileEarmarkPostFill } from "react-icons/bs";
import { MdOutlineSell } from "react-icons/md";
import { BiLogOut } from "react-icons/bi";
import { BsCurrencyDollar } from "react-icons/bs";
import { AiOutlineMessage } from "react-icons/ai";

import Logo from '../../assets/images/logo.svg'

// import PostAdd from "./PostAdd";
// import SellRequest from "./SellRequest";
// import Messages from "./Messages";
// import BuyOrders from "./BuyOrders";

import Post from "./post/index"

const Admin = () => {
  const history = useHistory();

  const [show, setShow] = React.useState("1");

  return (
    <>
      <div className="admin">
        <div className="sidebar">
          <div>
            <div className="logo">
              <img
                src={Logo}
                alt=""
              />
            </div>
          </div>

          <div className="main">
            <div
              className="menu"
              onClick={() => {
                setShow("1");
              }}
            >
              <div className={show === "1" ? "back" : "display-none"}>
                <div className="back-inner"></div>
              </div>

              <BsFillFileEarmarkPostFill className="icon" />
              <span>Post Add</span>
            </div>

            <div
              className="menu"
              onClick={() => {
                setShow("2");
              }}
            >
              <div className={show === "2" ? "back" : "display-none"}>
                <div className="back-inner"></div>
              </div>

              <MdOutlineSell className="icon" />
              <span>Sell Request</span>
            </div>

            <div
              className="menu"
              onClick={() => {
                setShow("3");
              }}
            >
              <div className={show === "3" ? "back" : "display-none"}>
                <div className="back-inner"></div>
              </div>

              <BsCurrencyDollar className="icon" />
              <span>Orders</span>
            </div>

            <div
              className="menu"
              onClick={() => {
                setShow("4");
              }}
            >
              <div className={show === "4" ? "back" : "display-none"}>
                <div className="back-inner"></div>
              </div>

              <AiOutlineMessage className="icon" />
              <span>Messages</span>
            </div>

            <div
              className="menu"
              onClick={() => {
                localStorage.removeItem("login");

                setTimeout(() => {
                  history.push("/login");
                }, 1000);
              }}
            >
              <BiLogOut className="icon" />
              <span>Logout</span>
            </div>
          </div>
        </div>

        <div className="right">
          
          {show === "1" ? 
            <Post />
          // ) : show === "2" ? (
          //   <SellRequest />
          // ) : show === "3" ? (
          //   <BuyOrders />
          // ) : show === "4" ? (
          //   <Messages />
          // ) 
          : null}
          
        </div>
      </div>
    </>
  );
};

export default Admin;
